import { useEffect, useState } from "react";
import { collection, orderBy, query } from "firebase/firestore";
import { useCollection } from "react-firebase-hooks/firestore";
import { db } from "@poseidon/firebase/firebase";
import config from "@poseidon/utils/config";
import { getDate } from "@poseidon/firebase/timestamp";

export const useKybNotesLog = (dealerId) => {
  const [kybNotesLog, setKybNotesLog] = useState([]);
  const [value, loading, error] = useCollection(
    query(
      collection(
        db,
        config.collections.DealerRiskProfile,
        dealerId,
        "kybNotes"
      ),
      orderBy("createdAt", "asc")
    )
  );
  useEffect(() => {
    if (value) {
      const docs = value.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
        createdAt: getDate(doc.get("createdAt")),
      }));
      setKybNotesLog(docs);
    }
  }, [value]);

  return { kybNotesLog, loading, error };
};
